export enum enumAwaitingTransactionStatus {
  'To be Authorized' = 1,
  'Authorized',
  'Expired',
  'Rejected',
  'Cancelled',
  'Manually Processed',
  'Waiting for New Merchant Acc',
  'Completed',
  'Reversed',
  'Reserved',
  // See C001 - 2026-08-20 - HE
  // ' Reservation To Auth'
  'Reservation To Auth'
}

export namespace enumAwaitingTransactionStatus {
  export function values() {
    return Object.keys(enumAwaitingTransactionStatus).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}

// ========================================
// CHANGE LOG
// ========================================
// C001: Corrected the value-11 label from ' Reservation To Auth' (leading space) to 'Reservation To Auth'. Previous behavior: enum key included a leading space, so enumAwaitingTransactionStatus[11] and values() would not match the ATA/FinCore display label. New behavior: Label is 'Reservation To Auth' with numeric value still 11. Reason: Align with ATA status table (1-11) for AwaitingTransactionService. Context: ATA Angular implementation guide 2026-08-20. Impact: Display/lookup of status 11; no API payload change (API uses numeric status). - 2026-08-20 - HE

